import type { Role } from '../store/auth.ts';
import { t } from './strings.ts';

/** Human-readable Thaana label for a role. */
export function roleLabel(role: Role): string {
  return t.roles[role];
}

/** ADMIN / SYS_ADMIN can do everything. */
export const isAdmin = (r: Role | null | undefined): boolean =>
  r === 'ADMIN' || r === 'SYS_ADMIN';

/** Procurement staff own the requisition → quotation → award flow, plus vendor mutations. */
export const canProcure = (r: Role | null | undefined): boolean =>
  r === 'STAFF' || isAdmin(r);

/** Finance owns award payment status. */
export const canFinance = (r: Role | null | undefined): boolean =>
  r === 'FINANCE' || isAdmin(r);

/** Stockkeeper owns Purchase Requests. */
export const canStock = (r: Role | null | undefined): boolean =>
  r === 'STOCKKEEPER' || isAdmin(r);
